import { OpportunitySelectionType, OpportunityType } from './Opportunity.enum';
import { OpportunityContextualType } from './OpportunityContextual.enum';
import type { IOpportunityContextual } from './OpportunityContextual.interface';

export default class OpportunityContextual implements IOpportunityContextual {
  selection: OpportunitySelectionType;
  type: OpportunityType;
  typeContextual: OpportunityContextualType;

  static build = (data: IOpportunityContextual) => new OpportunityContextual(data);
  static blank = (type: OpportunityType, typeContextual: OpportunityContextualType) =>
    new OpportunityContextual({ type, typeContextual });

  /**
   * Constructor
   * @param {IOpportunityContextual} data
   */
  constructor(data?: IOpportunityContextual) {
    this.selection = OpportunitySelectionType.of(data?.selection?.name);
    this.type = OpportunityType.of(data?.type?.name);
    this.typeContextual = OpportunityContextualType.of(data?.typeContextual?.name);
  }
}
